<span class="shelter-record-id">
  @let url = externalUrl();
  @if (!isAdopterUnknown() && url && app() !== 2) {
    <a
      class="shelter-record-id__link"
      [href]="url"
      target="_blank"
      rel="noopener noreferrer"
    >
      {{ recordId() }}
    </a>
  } @else {
    <span class="shelter-record-id__value">
      {{ recordId() }}
    </span>
  }

  <span class="shelter-record-id__actions">
    @if (allowCopy()) {
      <button
        type="button"
        class="shelter-record-id__copy"
        [attr.aria-label]="
          'Copy ' +
          recordLabel() +
          ' ' +
          recordId()
        "
        [attr.title]="
          copied()
            ? 'Copied'
            : 'Copy ' + recordLabel()
        "
        (click)="copyRecordId()"
      >
        <lib-icon
          class="shelter-record-id__copy-icon"
          iconName="utilityCopyIcon"
          aria-hidden="true"
        />
      </button>
    }

    @if (showShelterluvHelp() && !isAdopterUnknown()) {
      <span class="shelter-record-id__help-wrapper">
        <button
          type="button"
          class="shelter-record-id__help"
          [attr.aria-label]="
            'Shelterluv ' +
            recordLabel() +
            ' link help'
          "
          aria-describedby="shelterluv-linkout-tooltip"
        >
          <lib-icon
            class="shelter-record-id__help-icon"
            iconName="utilityHelpIcon"
            aria-hidden="true"
          />
        </button>

        <span
          id="shelterluv-linkout-tooltip"
          class="shelter-record-id__tooltip"
          role="tooltip"
        >
          Broken link? Make sure your Abbreviated Name in
          Petszel matches your Short Name in Shelterluv.

          <a
            class="shelter-record-id__tooltip-link"
            href="https://support.petszel.com/en-us/sheltersupport/why-are-my-link-outs-not-working-in-shelterluv?hs_preview=PcbZXWLs-188752473110"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn more
          </a>
        </span>
      </span>
    }
  </span>
</span>
